import type { SimplePaletteColorOptions } from '@mui/material'

const Color: Pick<SimplePaletteColorOptions, 'main'> = {
  main: '#80CFF6',
}

export default Color
